import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import i18next from 'i18next';

const gqlGetCpGroups = gql`
  query getCpGroups($where: String, $offset: Int, $limit: Int, $order: String) {
    getCpGroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
        isActive
      }
      recordCount
    }
  }
`;

// export function useGetCompanyTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>) {
//   return ApolloReactHooks.useLazyQuery<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>(GetCompanyTypesDocument, baseOptions);
// }

export function useGetGroupsAsOptionsQuery() {
  return useLazyQuery(gqlGetCpGroups, {
    fetchPolicy: 'cache-first',
  });
}

function useGetGroupsLazyQuery() {
  return useLazyQuery(gqlGetCpGroups, { fetchPolicy: 'cache-and-network' });
  //return [null, { loading: null, data: null }];
}

export const FieldSelectGroup = ({
  label = i18next.t('Κατηγορία'),
  name = 'groupId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      sbLabel={defaultValues?.cpGroup?.name ?? undefined}
      hook={useGetGroupsLazyQuery}
    />
  );
};

